"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColumn = exports.StyledIcon = exports.FlexContainer = exports.EllipsisText = exports.isIe = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
exports.isIe = false || !!document.documentMode;
var IEEllipsisText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: ", ";\n  overflow: hidden;\n  ", ";\n"], ["\n  line-height: ", ";\n  overflow: hidden;\n  ", ";\n"])), function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight;
}, function (_a) {
    var maxLineNum = _a.maxLineNum, lineHeight = _a.lineHeight;
    return "\n      position: relative;\n      max-height: calc(".concat(maxLineNum, " * ").concat(lineHeight, ");\n      text-align: justify;\n      padding-inline-end: 1em;\n      \n      :before {\n        content: '...';\n        position: absolute;\n        inset-inline-end: 0;\n        bottom: 0;\n        line-height: calc(").concat(lineHeight, " + 0.3em);\n      }\n      :after {\n        content: '';\n        position: absolute;\n        right: 0;\n        width: 1em;\n        height: 1em;\n        margin-top: 0.2em;\n        background: white;\n      }\n    ");
});
var StandardEllipsisText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: ", ";\n  overflow: hidden;\n  ", ";\n"], ["\n  line-height: ", ";\n  overflow: hidden;\n  ", ";\n"
    // ie-11 doesn't support webkit, so we need custom styles
])), function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight;
}, function (_a) {
    var maxLineNum = _a.maxLineNum;
    return "\n    display: -webkit-box;\n    -webkit-line-clamp: ".concat(maxLineNum, ";\n    -webkit-box-orient: vertical;\n    ");
});
// ie-11 doesn't support webkit, so we need custom styles
exports.EllipsisText = exports.isIe ? IEEllipsisText : StandardEllipsisText;
exports.FlexContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
exports.StyledIcon = (0, styled_components_1.default)(react_fontawesome_1.FontAwesomeIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: ", " 0;\n"], ["\n  margin: ", " 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.TextColumn = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin: 0 ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
